const LoggerMiddleware =
  ({ getState, dispatch }) =>
  next =>
  action => {
    let result = next(action);
    return result;
  };

export { LoggerMiddleware as default, LoggerMiddleware };
